import {useQuery} from "react-query";
import api from "../services/api";

const fetchCountries = () => {
    return api.get(`/countries`).then(response => response.data && response.data.data);
}

const useFetchCountries = (options = {}) => {
    return useQuery('countries', fetchCountries, {
        staleTime: Infinity,
        ...options,
    });
};

export default useFetchCountries;
